import { get, postWithToken } from "./Request";

const corePath = "Menu/";

export async function Get(query, token, edit) {
    return await get(`${corePath}Get?query=${query}&isEdit=true`);
}

export async function Add(model, token) {
    return await postWithToken(`${corePath}Add`, token, model);
}

export async function Delete(id, token) {
    return await postWithToken(`${corePath}Delete?id=${id}`, token, {});
}

export async function GetInfo(id, token) {
    return await get(`${corePath}GetInfo?id=${id}`, token);
}

